/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, mediaQuery, embedCorners, animations } from 'utils/styles';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// SCREEN STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default {
  screen: {
    background: 'rgba(0, 0, 0, 0.6)',
    extend: embedCorners,
    width: '100%',
    height: '100%',
    position: 'absolute',
    top: '0',
    left: '0',
    zIndex: '-1',
    opacity: '0',

    // active state of screen
    '&.active': {
      // animate in uniquecontent instead, screen will always stay in the DOM, but unique content will be removed and appended, so adding animation to it will always run
      // animationName: 'fadeIn',
      // animationDuration: '.7s',
      // animationDelay: '2s',
      //          animationFillMode: 'forwards',
      opacity: '1',
      zIndex: '5',
      overflow: 'hidden',
      '&.outOfContent': { zIndex: '2' }
    },

    // screen interior wrapper
    '& .screeninterior': {
      borderRadius: 'inherit',
      width: '100%',
      height: '100%',

      // ~~~~~~~~~~ ANIMATIONS ~~~~~~~~~~ //
      // animate in uniquecontent instead, screen will always stay in the DOM, but unique content will be removed and appended, so adding animation to it will always run
      '& .uniquecontent': {
        // '& .background': {
        // 	animationName: 'fadeIn',
        // 	animationDuration: '.5s',
        // 	animationDelay: '0s',
        // 	animationFillMode: 'forwards',
        // },
        '& .body': {
          extend: animations.textElements
        }
      },

      // unique screen
      '& .uniquescreen': {
        maxWidth: pxToEm(400),
        margin: '0 auto'
      },

      // now ensure the child DIV of this modal has rounded borders as well
      '& .background': {
        extend: embedCorners,
        '& .fade, .image': {
          borderRadius: 'inherit'
        }
      },
      '& .title h2': {
        lineHeight: '1.4'
      },
    }
  },

  // ++++++++++ MEDIA QUERIES ++++++++++ //
  [mediaQuery.thin]: {
    screen: { '& .uniquescreen': { fontSize: '85%' } }
  },
  [mediaQuery.short]: {
    screen: { '& .uniquescreen': { fontSize: '90%' } }
  },
  [mediaQuery.shorter]: {
    screen: { '& .uniquescreen': { fontSize: '86%' } }
  },
  [mediaQuery.shortest]: {
    screen: { '& .uniquescreen': { fontSize: '82%' } }
  }
};
